import { render, staticRenderFns } from "./TaxAuthoritySelect.vue?vue&type=template&id=1ada6e96&"
import script from "./TaxAuthoritySelect.vue?vue&type=script&lang=js&"
export * from "./TaxAuthoritySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports